export default {
  PAGE_COLOR: 'page-color',
  BOX_COLOR: 'box-color',
  BORDER_COLOR: 'border-color',
  BORDER_WIDTH_1: 'border-width-1',
  BORDER_WIDTH_2: 'border-width-2',

  BUTTON_FONT: 'button-font',
  BUTTON_FONT_COLOR: 'button-font-color',
  BUTTON_PRIMARY_TEXT_COLOR: 'button-primary-text-color',
  BUTTON_SECONDARY_TEXT_COLOR: 'button-secondary-text-color',
  BUTTON_OPACITY_AND_COLOR: 'button-opacity-and-color',
  FOLLOWERS_BUTTON_BORDER_OPACITY_AND_COLOR: 'followers-button-border-opacity-and-color',

  TEXT_PRIMARY_COLOR: 'text-color-primary',
  TEXT_SECONDARY_COLOR: 'text-color-secondary',
  TEXT_TITLE_COLOR: 'text-color-title',
  TEXT_STATISTICS_COLOR: 'text-statistics-color',
  TEXT_PRIMARY_FONT: 'text-primary-font',
  TEXT_SECONDARY_FONT: 'text-secondary-font',
  TEXT_TITLE_FONT: 'text-title-font',
  TEXT_STATISTICS_FONT: 'text-statistics-font',

  TEXT_LOGGED_OUT_TITLE_FONT: 'text-logged-out-title-font',
  TEXT_LOGGED_OUT_TITLE_COLOR: 'text-logged-out-title-color',
  TEXT_LOGGED_OUT_DESCRIPTION_FONT: 'text-logged-out-description-font',
  TEXT_LOGGED_OUT_DESCRIPTION_COLOR: 'text-logged-out-description-color',
  TEXT_NO_MEMBERS_TITLE_FONT: 'text-no-members-title-font',
  TEXT_NO_MEMBERS_TITLE_COLOR: 'text-no-members-title-color',
  TEXT_NO_MEMBERS_DESCRIPTION_FONT: 'text-no-members-description-font',
  TEXT_NO_MEMBERS_DESCRIPTION_COLOR: 'text-no-members-description-color',

  TEXT_POST_TITLE_COLOR: 'text-post-title-color',
  TEXT_POST_DESCRIPTION_COLOR: 'text-post-description-color',
  TEXT_POST_TITLE_FONT: 'text-post-title-font',
  TEXT_POST_DESCRIPTION_FONT: 'text-post-description-font',
  TEXT_POST_HOVER_COLOR: 'text-post-hover-color',

  POST_BACKGROUND_COLOR: 'post-background-color',
  POST_BORDER_COLOR: 'post-border-color',
  POST_BORDER_WIDTH: 'post-border-width',
  POST_TEXT_PADDING: 'post-list-text-padding',
  POST_CARD_WIDTH: 'post-list-card-width',
  POST_CARD_MARGIN: 'post-list-card-margin',
  POST_CARD_HEIGHT: 'post-list-card-height',

  PW_RESPONSIVE_NAME_COLOR: 'pw-responsive-name-color',
  PW_RESPONSIVE_NAME_FONT: 'pw-responsive-name-font',
  PW_RESPONSIVE_FF_COLOR: 'pw-responsive-ff-color',
  PW_RESPONSIVE_FF_FONT: 'pw-responsive-ff-font',
  PW_RESPONSIVE_BUTTON_COLOR: 'pw-responsive-button-color',
  PW_RESPONSIVE_BUTTON_FONT: 'pw-responsive-button-font',
  PW_COVER_COLOR: 'pw-cover-color',

  BADGE_LAYOUT: 'badge-layout',
  BADGE_SIZE: 'badge-size',
  BADGE_CORNER_RADIUS: 'badge-corner-radius',
  BADGE_FONT: 'badge-font',
  SHOW_BADGE_BACKGROUND: 'show-badge-background',

  SPACE_FROM_TOP: 'space-from-top',
  SPACE_BETWEEN_SECTIONS: 'space-between-sections',
  SPACE_OVERVIEW_INFORMATION: 'space-overview-information',
  SECTION_TITLE_FONT: 'section-title-font',
  SECTION_TITLE_COLOR: 'section-title-color',
  SECTION_DESCRIPTION_FONT: 'section-description-font',
  SECTION_DESCRIPTION_COLOR: 'section-description-color',
  FIELD_LABEL_FONT: 'field-label-font',
  FIELD_LABEL_COLOR: 'field-label-color',
  FIELD_TEXT_FONT: 'field-text-font',
  FIELD_TEXT_COLOR: 'field-text-color',
  FIELD_PLACEHOLDER_FONT: 'field-placeholder-font',
  FIELD_PLACEHOLDER_COLOR: 'field-placeholder-color',
  BADGE_DESCRIPTION_FONT: 'badge-description-font',
  BADGE_DESCRIPTION_COLOR: 'badge-description-color',
  EMPTY_STATE_TITLE_FONT: 'empty-state-title-font',
  EMPTY_STATE_TITLE_COLOR: 'empty-state-title-color',
  EMPTY_STATE_DESCRIPTION_FONT: 'empty-state-description-font',
  EMPTY_STATE_DESCRIPTION_COLOR: 'empty-state-description-color',

  DIVIDERS_COLOR: 'dividers-color',
  DIVIDERS_WIDTH: 'dividers-width',

  SHOW_FOLLOW_BUTTON: 'showFollowButton',
  SHOW_BADGES: 'showBadges',
  SHOW_MESSAGE_BUTTON: 'showMessageButton',
  SHOW_FOLLOWERS_FOLLOWING: 'showFollowersFollowing',
  DEFAULT_COVER_PHOTO: 'defaultCoverPhotoUrl',
  DEFAULT_COVER_PHOTO_OPACITY: 'defaultCoverPhotoOpacity',

  FOLLOWERS_BUTTON_CORNER_RADIUS: 'followersButtonCornerRadius',
  FOLLOWERS_BUTTON_BORDER_WIDTH: 'followersButtonBorderWidth',

  MEMBERS_BUTTON_CORNER_RADIUS: 'membersButtonCornerRadius',
  MEMBERS_CARD_CORNER_RADIUS: 'membersCardCornerRadius',
};
